export default "__VITE_ASSET__Cur66anR__"